import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const SectionHeader = ({ 
  badge = "Pricing", 
  title = "A Plan for Every Need", 
  subtitle = "Craftify unites marketers, designers, and developers to create, manage, and optimize impactful web experiences",
  badgeIcon: Icon = Sparkles,
  accentColor = "gold" // "gold", "green", or "teal"
}) => {
  const colors = {
    gold: {
      badge: '#EFCD86',
      line: '#EFCD86',
      glow: 'rgba(239, 205, 134, 0.2)'
    },
    green: {
      badge: '#66B152',
      line: '#66B152',
      glow: 'rgba(102, 177, 82, 0.2)'
    },
    teal: {
      badge: '#046A8C',
      line: '#046A8C',
      glow: 'rgba(4, 106, 140, 0.2)'
    }
  };

  const theme = colors[accentColor];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-16"
    >
      {/* Badge with decorative lines */}
      <div className="flex items-center justify-center gap-4 mb-6">
        {/* Left line */}
        <div className="flex items-center gap-2">
          <div 
            className="h-px w-12"
            style={{ background: `linear-gradient(to right, transparent, ${theme.line})` }}
          />
          <div 
            className="w-1.5 h-1.5 rounded-full"
            style={{ backgroundColor: theme.line }}
          />
        </div>

        {/* Badge */}
        <div 
          className="flex items-center gap-2 px-4 py-2 rounded-full border backdrop-blur-sm"
          style={{ 
            borderColor: `${theme.badge}40`,
            backgroundColor: 'rgba(13, 31, 51, 0.8)'
          }}
        >
          <Icon size={16} style={{ color: theme.badge }} />
          <span 
            className="text-sm font-medium"
            style={{ color: theme.badge }}
          >
            {badge}
          </span>
        </div>

        {/* Right line */}
        <div className="flex items-center gap-2">
          <div 
            className="w-1.5 h-1.5 rounded-full"
            style={{ backgroundColor: theme.line }}
          />
          <div 
            className="h-px w-12"
            style={{ background: `linear-gradient(to left, transparent, ${theme.line})` }}
          />
        </div>
      </div>

      {/* Main Title */}
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
        {title}
      </h2>

      {/* Subtitle */}
      <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
        {subtitle}
      </p>
    </motion.div>
  );
};

export default SectionHeader;
